export default __webpack_public_path__ + "static/preview-platform-d9e806ed48367b682536b1182249a4f8.png";